import React from 'react';
import FeedbackReportModal from '../FeedbackReportModal/FeedbackReportModal';
import './FeedbackReport.css';

const FeedbackReport = ({
	onStartCapture,
	screenCapture,
	handleScreenshot,
	onPopupToggle,
	isPopupOpen,
	setIsPopupOpen,
	setIssueTitle,
	issueTitle,
	handleClearScreenshot,
	setShowRecorder,
	showRecorder,
	setIssueDescription,
	issueDescription,
	mediaBlobUrl,
	status,
	resetMediaBlobUrl,
	projectKey,
	setSuccessJiraMessage,
	successJiraMessage,
	createJiraIssue,
	handleAttachmentChange,
	attachmentFile,
	setAttachmentFile,
	email,
	setEmail,
	handleReset,
	onClosePopup,
	popupType,
	setPopupType,
	handleRemoveAttachmentFile,
	inputFileRef,
	setSubmitLoader,
	submitLoader,
}) => {
	// const [image, takeScreenshot] = useScreenshot({
	// 	type: 'image/jpeg',
	// 	quality: 1.0,
	// });

	return (
		<>
			<div className="container">
				{/* {status === 'recording' ? (
					<></>
				) : (
					<button className="bottom-right-button" onClick={onPopupToggle}>
					<svg
              width="12"
              height="15"
              viewBox="0 0 12 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 14.3334L4 12.3334H1.33333C0.966667 12.3334 0.652778 12.2028 0.391667 11.9417C0.130556 11.6806 0 11.3667 0 11V1.66671C0 1.30004 0.130556 0.986152 0.391667 0.725041C0.652778 0.46393 0.966667 0.333374 1.33333 0.333374H10.6667C11.0333 0.333374 11.3472 0.46393 11.6083 0.725041C11.8694 0.986152 12 1.30004 12 1.66671V11C12 11.3667 11.8694 11.6806 11.6083 11.9417C11.3472 12.2028 11.0333 12.3334 10.6667 12.3334H8L6 14.3334ZM5.93333 10.3334C6.16667 10.3334 6.36389 10.2528 6.525 10.0917C6.68611 9.9306 6.76667 9.73337 6.76667 9.50004C6.76667 9.26671 6.68611 9.06949 6.525 8.90837C6.36389 8.74726 6.16667 8.66671 5.93333 8.66671C5.7 8.66671 5.50278 8.74726 5.34167 8.90837C5.18056 9.06949 5.1 9.26671 5.1 9.50004C5.1 9.73337 5.18056 9.9306 5.34167 10.0917C5.50278 10.2528 5.7 10.3334 5.93333 10.3334ZM5.33333 7.76671H6.56667C6.56667 7.57782 6.575 7.41671 6.59167 7.28337C6.60833 7.15004 6.64444 7.02226 6.7 6.90004C6.75556 6.77782 6.825 6.66393 6.90833 6.55837C6.99167 6.45282 7.11111 6.32226 7.26667 6.16671C7.65556 5.77782 7.93056 5.45282 8.09167 5.19171C8.25278 4.9306 8.33333 4.63337 8.33333 4.30004C8.33333 3.71115 8.13333 3.23615 7.73333 2.87504C7.33333 2.51393 6.79445 2.33337 6.11667 2.33337C5.50556 2.33337 4.98611 2.48337 4.55833 2.78337C4.13056 3.08337 3.83333 3.50004 3.66667 4.03337L4.76667 4.46671C4.84444 4.16671 5 3.92504 5.23333 3.74171C5.46667 3.55837 5.73889 3.46671 6.05 3.46671C6.35 3.46671 6.6 3.54726 6.8 3.70837C7 3.86949 7.1 4.08337 7.1 4.35004C7.1 4.53893 7.03889 4.73893 6.91667 4.95004C6.79444 5.16115 6.58889 5.39448 6.3 5.65004C6.11111 5.8056 5.95833 5.95837 5.84167 6.10837C5.725 6.25837 5.62778 6.41671 5.55 6.58337C5.47222 6.75004 5.41667 6.92504 5.38333 7.10837C5.35 7.29171 5.33333 7.51115 5.33333 7.76671Z"
                fill="white"
              />
            </svg>
						<span style={{marginLeft: '10px'}}>Report & track issues</span>
					</button>
				)} */}
				{/* <button className="bottom-right-button" onClick={onPopupToggle}>
					Feedback Report
				</button> */}
			</div>
			{isPopupOpen && (
				<FeedbackReportModal
					screenCapture={screenCapture}
					onStartCapture={onStartCapture}
					onPopupToggle={onPopupToggle}
					handleScreenshot={handleScreenshot}
					setIsPopupOpen={setIsPopupOpen}
					isPopupOpen={isPopupOpen}
					issueTitle={issueTitle}
					setIssueTitle={setIssueTitle}
					handleClearScreenshot={handleClearScreenshot}
					showRecorder={showRecorder}
					setShowRecorder={setShowRecorder}
					issueDescription={issueDescription}
					setIssueDescription={setIssueDescription}
					mediaBlobUrl={mediaBlobUrl}
					status={status}
					resetMediaBlobUrl={resetMediaBlobUrl}
					projectKey={projectKey}
					successJiraMessage={successJiraMessage}
					setSuccessJiraMessage={setSuccessJiraMessage}
					createJiraIssue={createJiraIssue}
					handleAttachmentChange={handleAttachmentChange}
					attachmentFile={attachmentFile}
					setAttachmentFile={setAttachmentFile}
					email={email}
					setEmail={setEmail}
					handleReset={handleReset}
					onClosePopup={onClosePopup}
					popupType={popupType}
					setPopupType={setPopupType}
					handleRemoveAttachmentFile={handleRemoveAttachmentFile}
					inputFileRef={inputFileRef}
					setSubmitLoader={setSubmitLoader}
					submitLoader={submitLoader}
				/>
			)}
		</>
	);
};

export default FeedbackReport;
